import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "toggle"]

  expand() {
    this.detailsTarget.classList.remove("hidden")
    this.toggleTarget.classList.add("hidden")
  }

  collapse() {
    this.detailsTarget.classList.add("hidden")
    this.toggleTarget.classList.remove("hidden")
  }
}
